import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MusicPlayer } from "@/components/MusicPlayer";
import Home from "@/pages/Home";
import Dictionary from "@/pages/Dictionary";
import MapPage from "@/pages/MapPage";
import Proverbs from "@/pages/Proverbs";
import Timeline from "@/pages/Timeline";
import Quiz from "@/pages/Quiz";
import About from "@/pages/About";

const ScrollTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return null;
};

function App() {
  return (
    <ThemeProvider>
      <div className="App parchment min-h-screen flex flex-col overflow-x-hidden">
        <BrowserRouter>
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/sozluk" element={<Dictionary />} />
              <Route path="/harita" element={<MapPage />} />
              <Route path="/savlar" element={<Proverbs />} />
              <Route path="/zaman" element={<Timeline />} />
              <Route path="/oyun" element={<Quiz />} />
              <Route path="/hakkinda" element={<About />} />
            </Routes>
          </main>
          <Footer />
          <MusicPlayer />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </ThemeProvider>
  );
}

export default App;
